export default "__VITE_ASSET__DYFzfhFg__"